export const MODULE_PUBLISHING_TIMEOUT = 30
export const DEPLOY_API_REFRESH_INTERVAL = 1000
